// extracted by mini-css-extract-plugin
export default {"progressCircle":"IssueItemSubIssuesSummary-module__progressCircle--B_9jW","token":"IssueItemSubIssuesSummary-module__token--lQcLp"};